import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status"]
  static values = { url: String }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.urlValue)
      this.statusTarget.textContent = "登入網址已複製，請貼到 Safari 或 Chrome 開啟。"
    } catch {
      this.statusTarget.textContent = "無法自動複製，請使用 LINE 選單中的「使用預設瀏覽器開啟」。"
    }

    this.statusTarget.classList.remove("hidden")
  }
}
